import { createAsyncThunk } from '@reduxjs/toolkit'
import { Dispatch } from 'redux'
import { Payload, Query, redirect } from 'redux-first-router'

import { SharedState } from '../sharedState'

export const redirectToThunk = createAsyncThunk<
  void,
  { payload: Payload; query?: Query; type: string },
  { dispatch: Dispatch; state: SharedState }
>(
  'filters/updateFilters',
  async ({ payload, query, type }, { dispatch, getState }) => {
    const state: SharedState = getState()
    const {
      location: { payload: originalPayload },
    } = state

    dispatch(
      redirect({
        payload: { ...originalPayload, ...payload },
        query: {
          ...originalPayload.query,
          ...query,
        },
        type,
      }),
    )
  },
)
